import React from "react";

import R from "ramda";

import { Arrow } from "src/icons";

import { themeColor } from "src/styles";

import { Box, Flex, PlainImage, Link, Text } from "src/components/base";

export default ({ item: page, ...props }) => {
  const description = R.path(["description", "description"], page);

  return (
    <Box flex={1}
      display="flex">
      <Link
        to={page.url}
        bg={themeColor(page.theme)}
        px={3}
        py={2}
        color="white"
        borderRadius={[0, 0, 0, 2]}
        flex={1}
        // height={[null, null, 150, 200]}
        style={{ textDecoration: "none" }}
        flexDirection={["row-reverse", "row-reverse", "row-reverse", "column"]}
      >
        <Flex
          flexDirection="row"
          justify="space-between"
          align="center"
          flex={[5, 5, 5, 2, 1]}
        >
          <Text
            upper={true}
            fontWeight="semibold"
            textTransform="uppercase"
            underline="none"
            mr={2}
            flex={1}
          >
            {page.title}
          </Text>
          <Arrow size={15} />
        </Flex>
        {/* <Flex flex={[1, 1, 4]} align="center" justify="center" mr={[2, 2, 0]}>
          {page.icon && (
            <PlainImage
              src={page.icon.file.url}
              height={[30, 30, 40, 50, 75]}
              width={[30, 30, 40, 50, 75]}
              alt={`An icon representing the ${page.title} page`}
            />
          )}
        </Flex> */}
      </Link>
      {description && (
        <Box display={["none", "none", "none", "block"]}>
          <Text my={2} fontWeight="medium">
            {description}
          </Text>
        </Box>
      )}
    </Box>
  );
};

export const iconButtonFragment = graphql`
  fragment IconButtonPage on ContentfulPage {
    id
    title
    theme
    url
    description {
      description
    }
    icon {
      file {
        url
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/components/ItemGroup/IconButton.js